module.exports = __webpack_public_path__ + "static/media/homePage_crypto.b1a30b6d.jpg";